import React, { useEffect, useRef, useState } from "react";
import customer from "../../../../assets/images/company-image.jpg";

const Customer = () => {
  const list = [
    { description: "Choose the right vehicle for your needs" },
    { description: "Set the timing that works best for you" },
    { description: "Negotiate prices directly with nearby drivers" },
    { description: "Connect only with verified and trusted drivers" },
  ];

  const maxHeight = window.innerHeight;
  const sectionRef = useRef(null);
  const [fontScale, setFontScale] = useState(1);
  const [isFixed, setIsFixed] = useState(false);
  const [startScroll, setStartScroll] = useState(0);
  const [borderRadius, setBorderRadius] = useState(0);

  useEffect(() => {
    if (sectionRef.current) {
      setStartScroll(sectionRef.current.offsetTop);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY >= startScroll && scrollY <= startScroll + maxHeight) {
        setIsFixed(true);
        const scrolled = scrollY - startScroll;
        const shrinkRatio = Math.max((maxHeight - scrolled) / maxHeight, 0);

        setFontScale(shrinkRatio);
        setBorderRadius(120 * (1 - shrinkRatio)); // smoother, bigger curve
      } else if (scrollY < startScroll) {
        setIsFixed(false);
        setFontScale(1);
        setBorderRadius(0);
      } else {
        setIsFixed(true);
        setFontScale(0);
        setBorderRadius(120);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [startScroll]);

  return (
    <>
      {window.innerWidth > 1024 ? (
        <>
          {/* Spacer to prevent layout jump */}
          <div
            className="place-holder-div"
            style={{
              height: isFixed ? `${maxHeight}px` : "auto",
            }}
          />
          <div
            ref={sectionRef}
            style={{
              height: `${maxHeight}px`,
              width: "100%",
              background: "#fff",
              borderRadius: `${borderRadius}px`,
              position: isFixed ? "fixed" : "relative",
              top: 0,
              right: 0, // right align
              left: "auto", // no left position
              transform: `scale(${fontScale})`,
              transformOrigin: "top left", // scale from right
              zIndex: 1000,
            }}
          >
            <CustomerContent list={list} borderRadius={borderRadius} />
          </div>
        </>
      ) : (
        <CustomerContent list={list} />
      )}
    </>
  );
};

const CustomerContent = ({ list, borderRadius }) => {
  return (
    <div
      className="customer-container"
      style={{
        height: "94%",
        borderRadius: borderRadius,
        width: "auto",
        padding: "0px 60px 60px 60px",
      }}
    >
      <div className="image-container">
        <img
          className="customer-image"
          src={customer}
          alt="Customer"
          style={{
            maxWidth: "70%",
          }}
        />
      </div>
      <div className="container-description" style={{ fontSize: "0.9rem" }}>
        <div className="customer-heading" style={{ fontSize: "2rem" }}>
          <span>For Customers: Trusted Loading Services at Fair Prices</span>
        </div>
        <div className="customer-description" style={{ fontSize: "1.2rem" }}>
          <span>
We know how frustrating it is when you need help moving something and can’t find someone reliable or worse, end up paying more than you should. ZOWO lets you take full control. Your schedule, your budget, your deal; made simple and fair every time.
          </span>
        </div>
        <div className="customer-list">
          {list.map((item, index) => (
            <div
              key={index}
              className="list-item-customer"
              style={{ fontSize: "0.85rem" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={30}
                height={10}
                viewBox="0 0 43 14"
                fill="none"
              >
                <path
                  d="M42.6762 5.86504L31.6524 1.36381L33.2661 13.1613L42.6762 5.86504ZM1.08411 1.05273L0.659674 1.99255C6.54595 4.65087 19.8798 8.80063 33.5313 8.15267L33.4824 7.12262L33.4335 6.09257C20.1897 6.72118 7.18342 2.67577 1.50854 0.11292L1.08411 1.05273Z"
                  fill="black"
                />
              </svg>
              <span>{item.description}</span>
            </div>
          ))}
        </div>
        <button className="ride-with-us" style={{ fontSize: "0.9rem" }}>
          Ride With Us
        </button>
      </div>
    </div>
  );
};

export default Customer;
